// Silo v2 — ISilo (subset)
//
// Each Silo is an ERC-4626 vault with three share types:
//   - Collateral (lendable, earns borrower interest) — the silo itself
//   - Protected (not lendable, no interest)           — separate ERC-20
//   - Debt                                            — separate ERC-20
//
// Public-data fetcher:  `totalAssets()`, `getDebtAssets()`
// User-data fetcher:    `balanceOf`, `convertToAssets(shares, assetType)`,
//                       `maxRepay(borrower)`
//
// AssetType enum: 0 = Protected, 1 = Collateral, 2 = Debt
//
// Reference:
//   https://github.com/silo-finance/silo-contracts-v2/blob/develop/silo-core/contracts/interfaces/ISilo.sol
export const SiloAbi = [
  {
    type: 'function',
    name: 'totalAssets',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'getDebtAssets',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'getCollateralAssets',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'asset',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'address' }],
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ name: '', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'convertToAssets',
    stateMutability: 'view',
    inputs: [{ name: 'shares', type: 'uint256' }],
    outputs: [{ name: '', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'maxRepay',
    stateMutability: 'view',
    inputs: [{ name: 'borrower', type: 'address' }],
    outputs: [{ name: '', type: 'uint256' }],
  },
] as const

/**
 * Separate ABI for the 2-arg `convertToAssets(uint256, uint8)` overload.
 *
 * ISilo has both a standard ERC-4626 1-arg `convertToAssets(uint256)` and a
 * Silo-specific 2-arg `convertToAssets(uint256, uint8)` where the second
 * param is the `AssetType` enum (0 = Protected, 1 = Collateral, 2 = Debt).
 *
 * viem cannot disambiguate overloaded function names within a single ABI,
 * so calls using the 2-arg variant must carry this ABI via the per-call
 * `abi` field (same pattern as `CreamLensV2Abi` in compound-v2).
 */
export const SiloConvertToAssetsTypedAbi = [
  {
    type: 'function',
    name: 'convertToAssets',
    stateMutability: 'view',
    inputs: [
      { name: 'shares', type: 'uint256' },
      { name: 'assetType', type: 'uint8' },
    ],
    outputs: [{ name: '', type: 'uint256' }],
  },
] as const
